import Styles from './styles.module.css';
import AlbumLogo from './../../../image/home/salonLogoOfficial/album.svg';
import AbbeyLogo from './../../../image/home/salonLogoOfficial/abbey.svg';
import AshLogo from './../../../image/home/salonLogoOfficial/ash.png';
import AtelierHarukaLogo from './../../../image/home/salonLogoOfficial/atelier-haruka.svg';
import BlancoLogo from './../../../image/home/salonLogoOfficial/blanco.png';
import CasheCasheLogo from './../../../image/home/salonLogoOfficial/cashecashe.jpg';
import CoaLogo from './../../../image/home/salonLogoOfficial/coa.svg';
import EarthLogo from './../../../image/home/salonLogoOfficial/earth.png';
import KenjeLogo from './../../../image/home/salonLogoOfficial/kenje.png';
import LondLogo from './../../../image/home/salonLogoOfficial/lond.png';
import MashuLogo from './../../../image/home/salonLogoOfficial/mashu.png';
import MinxLogo from './../../../image/home/salonLogoOfficial/minx.svg';
import ModeksLogo from './../../../image/home/salonLogoOfficial/modeks.svg';
import ModshairLogo from './../../../image/home/salonLogoOfficial/modshair.svg';
import NeoliveLogo from './../../../image/home/salonLogoOfficial/neolive.svg';
import OfHairLogo from './../../../image/home/salonLogoOfficial/ofhair.svg';
import PeleLogo from './../../../image/home/salonLogoOfficial/pele.png';
import QbHouseLogo from './../../../image/home/salonLogoOfficial/qbhouse.svg';
import SkillLogo from './../../../image/home/salonLogoOfficial/skill.png';
import TayaLogo from './../../../image/home/salonLogoOfficial/taya.svg';
// ▼▼▼ 許可確認待ち枠（許可が取れたらこの11行のコメントを外す＋下のLOGOS配列も戻す） ▼▼▼
// import AfloatLogo from './../../../image/home/salonLogoOfficial/afloat.svg';
// import ApishLogo from './../../../image/home/salonLogoOfficial/apish.png';
// import EuphoriaLogo from './../../../image/home/salonLogoOfficial/euphoria.png';
// import HiroGinzaLogo from './../../../image/home/salonLogoOfficial/hiroginza.svg';
// import KainoLogo from './../../../image/home/salonLogoOfficial/kaino.svg';
// import MslashLogo from './../../../image/home/salonLogoOfficial/mslash.png';
// import SandLogo from './../../../image/home/salonLogoOfficial/sand.png';
// import ShiseidoLogo from './../../../image/home/salonLogoOfficial/shiseido.png';
// import SocieLogo from './../../../image/home/salonLogoOfficial/socie.png';
// import TheaterLogo from './../../../image/home/salonLogoOfficial/theater.png';
// import ToniAndGuyLogo from './../../../image/home/salonLogoOfficial/toniandguy.svg';
// ▲▲▲ 許可確認待ち枠ここまで ▲▲▲

type LogoItem = {
  src: string;
  alt: string;
  className?: string;
};

const LOGOS: LogoItem[] = [
  { src: CoaLogo, alt: 'COA' },
  { src: AshLogo, alt: 'Ash', className: Styles.ashLogo },
  { src: ModshairLogo, alt: "mod's hair" },
  { src: AbbeyLogo, alt: 'ABBEY' },
  { src: KenjeLogo, alt: 'KENJE GROUP' },
  { src: BlancoLogo, alt: 'BLANCO' },
  { src: QbHouseLogo, alt: 'QB HOUSE' },
  { src: PeleLogo, alt: 'PELE' },
  { src: MinxLogo, alt: 'MINX' },
  { src: LondLogo, alt: 'Lond' },
  { src: SkillLogo, alt: 'skill', className: Styles.skillLogo },
  { src: ModeksLogo, alt: "MODE K's" },
  { src: AtelierHarukaLogo, alt: 'アトリエはるか' },
  { src: TayaLogo, alt: 'TAYA' },
  { src: AlbumLogo, alt: 'ALBUM' },
  { src: OfHairLogo, alt: 'Of HAIR' },
  { src: EarthLogo, alt: 'HAIR & MAKE EARTH' },
  { src: NeoliveLogo, alt: 'Neolive' },
  { src: MashuLogo, alt: 'MASHU' },
  { src: CasheCasheLogo, alt: 'cashecashe' },
  // ▼▼▼ 許可確認待ち枠（許可が取れたらこの11行のコメントを外す＋上のimportも戻す） ▼▼▼
  // { src: AfloatLogo, alt: 'AFLOAT' },
  // { src: KainoLogo, alt: 'KAINO' },
  // { src: ToniAndGuyLogo, alt: 'TONI&GUY' },
  // { src: ApishLogo, alt: 'apish' },
  // { src: SandLogo, alt: 'sand', className: Styles.sandLogo },
  // { src: TheaterLogo, alt: 'THEATER', className: Styles.invertLogo },
  // { src: EuphoriaLogo, alt: 'Euphoria' },
  // { src: HiroGinzaLogo, alt: 'HIRO GINZA' },
  // { src: SocieLogo, alt: 'SOCIE' },
  // { src: ShiseidoLogo, alt: '資生堂美容室', className: Styles.shiseidoLogo },
  // { src: MslashLogo, alt: 'M.SLASH' },
  // ▲▲▲ 許可確認待ち枠ここまで ▲▲▲
];

type HomeLogoProps = {
  /** 見出し文言。省略時は FV 直下用のデフォルト */
  lead?: string;
};

const HomeLogo = ({ lead = '多くのサロンにご利用いただいています' }: HomeLogoProps) => {

  return (
    <div className={Styles.section}>
      <div className={Styles.head}>
        <span className={Styles.kicker}>Partner salons</span>
        <p className={Styles.lead}>{lead}</p>
      </div>
      <div className={Styles.grid}>
        {LOGOS.map((logo) => (
          <div key={logo.alt} className={Styles.tile}>
            <img src={logo.src} alt={logo.alt} className={logo.className} />
          </div>
        ))}
      </div>
    </div>
  );
}


export default HomeLogo;
